[
  {
    "minLevel": 1,
    "maxLevel": 19,
    "requirement": 15,
    "rewardGems": 200
  },
  {
    "minLevel": 20,
    "maxLevel": 49,
    "requirement": 30,
    "rewardGems": 200
  },
  {
    "minLevel": 50,
    "maxLevel": 99,
    "requirement": 40,
    "rewardGems": 200
  },
  {
    "minLevel": 100,
    "requirement": 45,
    "rewardGems": 200
  }
]
